import * as i0 from '@angular/core';
import * as i1 from './file-upload.module';
import * as i2 from '@angular/common';
import * as i3 from '../alert-box/alert-box.component';
import * as i4 from '../draggable/draggable.directive';
import * as i5 from '../draggable/droppable.directive';
import * as i6 from './file-upload.component';
import * as i7 from './file-upload-preview.component';
import * as i8 from '../alert-box/alert-box.module';
import * as i9 from '../draggable/draggable.module';
export const FileUploadModuleNgFactory:i0.NgModuleFactory<i1.FileUploadModule> = (null as any);
var _decl0_0:i2.NgClass = (<any>(null as any));
var _decl0_1:i2.NgComponentOutlet = (<any>(null as any));
var _decl0_2:i2.NgForOf<any> = (<any>(null as any));
var _decl0_3:i2.NgIf = (<any>(null as any));
var _decl0_4:i2.NgTemplateOutlet = (<any>(null as any));
var _decl0_5:i2.NgStyle = (<any>(null as any));
var _decl0_6:i2.NgSwitch = (<any>(null as any));
var _decl0_7:i2.NgSwitchCase = (<any>(null as any));
var _decl0_8:i2.NgSwitchDefault = (<any>(null as any));
var _decl0_9:i2.NgPlural = (<any>(null as any));
var _decl0_10:i2.NgPluralCase = (<any>(null as any));
var _decl0_11:i3.AlertBoxComponent = (<any>(null as any));
var _decl0_12:i4.DraggableDirective = (<any>(null as any));
var _decl0_13:i4.DraggableHandleDirective = (<any>(null as any));
var _decl0_14:i5.DroppableDirective = (<any>(null as any));
var _decl0_15:i6.FileUploadComponent = (<any>(null as any));
var _decl0_16:i7.FileUploadPreviewComponent = (<any>(null as any));
var _decl0_17:i2.AsyncPipe = (<any>(null as any));
var _decl0_18:i2.UpperCasePipe = (<any>(null as any));
var _decl0_19:i2.LowerCasePipe = (<any>(null as any));
var _decl0_20:i2.JsonPipe = (<any>(null as any));
var _decl0_21:i2.SlicePipe = (<any>(null as any));
var _decl0_22:i2.DecimalPipe = (<any>(null as any));
var _decl0_23:i2.PercentPipe = (<any>(null as any));
var _decl0_24:i2.TitleCasePipe = (<any>(null as any));
var _decl0_25:i2.CurrencyPipe = (<any>(null as any));
var _decl0_26:i2.DatePipe = (<any>(null as any));
var _decl0_27:i2.I18nPluralPipe = (<any>(null as any));
var _decl0_28:i2.I18nSelectPipe = (<any>(null as any));
var _decl0_29:i2.KeyValuePipe = (<any>(null as any));
var _decl0_30:i2.CommonModule = (<any>(null as any));
var _decl0_31:i8.AlertBoxModule = (<any>(null as any));
var _decl0_32:i9.DraggableModule = (<any>(null as any));
var _decl0_33:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_34:i0.ElementRef<any> = (<any>(null as any));
function _View_FileUploadComponent_Host_1_0():void {
  var _any:any = (null as any);
}
function _View_FileUploadComponent_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = '';
  currVal_0;
  const currVal_1:any = i0.ɵinlineInterpolate(1,'file-upload ',_decl0_15.cssClass,
      '');
  currVal_1;
  const currVal_2:any = (<any>{$implicit:_decl0_15});
  currVal_2;
  const currVal_3:any = (_decl0_15.toolbarTemplate || _any);
  currVal_3;
  const currVal_4:any = (_decl0_15.showErrors && _decl0_15.errors.length);
  currVal_4;
  const currVal_5:any = (<any>{$implicit:_decl0_15});
  currVal_5;
  const currVal_6:any = (_decl0_15.previewTemplate || _any);
  currVal_6;
  const pd_7:any = ((<any>_decl0_15.newFileChoose(_any)) !== false);
  const pd_8:any = ((<any>_decl0_15.onDropFiles(_any)) !== false);
}
function _View_FileUploadPreviewComponent_Host_2_0():void {
  var _any:any = (null as any);
}
function _View_FileUploadPreviewComponent_2_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_16.selectFiles;
  currVal_0;
}
